export default "__VITE_ASSET__0af2fff2__"